import { render } from "./stat-progress.vue?vue&type=template&id=546294c2&scoped=true"
import script from "./stat-progress.vue?vue&type=script&lang=js"
export * from "./stat-progress.vue?vue&type=script&lang=js"

import "./stat-progress.vue?vue&type=style&index=0&id=546294c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546294c2"]])

export default __exports__